import { useEffect, useRef, useState } from "react";
import { Upload, Trash2, Copy } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";

export default function MediaLibrary() {
  const [items, setItems] = useState([]);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const load = () => api.get("/admin/media").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    try {
      for (const file of files) {
        const fd = new FormData();
        fd.append("file", file);
        await api.post("/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } });
      }
      load();
    } catch (err) { alert("Upload failed: " + (err.response?.data?.detail || err.message)); }
    finally { setUploading(false); if (fileRef.current) fileRef.current.value = ""; }
  };
  const del = async (id) => { if (window.confirm("Delete image?")) { await api.delete(`/admin/media/${id}`); load(); } };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3"><h1 className="font-heading font-700 text-2xl text-lp-blue">Media Library</h1><span className="text-sm text-lp-muted bg-white border border-lp-border rounded-sm px-2.5 py-0.5">{items.length}</span></div>
        <button onClick={() => fileRef.current?.click()} disabled={uploading} data-testid="media-lib-upload" className="inline-flex items-center gap-2 bg-lp-blue text-white font-600 px-4 py-2.5 rounded-sm text-sm disabled:opacity-60"><Upload size={15} /> {uploading ? "Uploading…" : "Upload Images"}</button>
        <input ref={fileRef} type="file" accept="image/*" multiple className="hidden" onChange={upload} />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {items.map((m) => (
          <div key={m.id} className="group relative border border-lp-border rounded-sm overflow-hidden bg-white">
            <div className="aspect-square"><img src={mediaUrl(m.url)} alt={m.original_filename} className="w-full h-full object-cover" /></div>
            <div className="p-2 text-[11px] text-lp-muted truncate">{m.original_filename}</div>
            <div className="absolute top-1 right-1 flex gap-1 opacity-0 group-hover:opacity-100">
              <button onClick={() => navigator.clipboard.writeText(mediaUrl(m.url))} title="Copy URL" className="bg-white/90 rounded-sm p-1 text-lp-blue"><Copy size={13} /></button>
              <button onClick={() => del(m.id)} className="bg-white/90 rounded-sm p-1 text-destructive"><Trash2 size={13} /></button>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="col-span-full text-center text-lp-muted py-16">No media uploaded yet.</p>}
      </div>
    </div>
  );
}
